/* The Snout — site interactions (header, cart, product cards, tabs, rails, video) */
(function () {
  'use strict';
  var d = document;

  /* ---------------- Cart helpers ---------------- */
  function cartDrawer() {
    var el = d.querySelector('theme-drawer#cart-drawer');
    return el && typeof el.open === 'function' ? el : null;
  }

  function openCart() {
    var drawer = cartDrawer();
    if (drawer) { drawer.open(); return true; }
    return false;
  }

  function setCartCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    d.querySelectorAll('[data-sn-cart-count]').forEach(function (el) {
      var prev = parseInt(el.textContent, 10) || 0;
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
      if (n > prev) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
    d.querySelectorAll('[data-sn-cart-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }

  function refreshCartCount() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }

  // Keep the header count in sync with every cart change on the page (drawer edits, removals, apps).
  d.addEventListener('shopify:cart:lines-update', function (e) {
    if (e && e.promise && typeof e.promise.then === 'function') {
      e.promise.then(function (res) {
        var n = res && res.cart && typeof res.cart.totalQuantity === 'number' ? res.cart.totalQuantity
          : res && res.detail && typeof res.detail.itemCount === 'number' ? res.detail.itemCount : null;
        if (n !== null) setCartCount(n); else refreshCartCount();
      }).catch(function () {});
    }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });

  d.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-sn-cart-toggle]');
    if (!toggle) return;
    if (openCart()) e.preventDefault(); // falls back to the /cart page when no drawer exists
  });

  /* ---------------- Product card add to cart ---------------- */
  function showCardError(form, msg) {
    var box = form.parentElement && form.parentElement.querySelector('.sn-card__error');
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
    setTimeout(function () { box.hidden = true; }, 6000);
  }

  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-sn-add-form]')) return;
    var submitter = e.submitter;
    // "Buy Now" posts natively to /cart/add with return_to=/checkout — straight into checkout.
    if (submitter && submitter.hasAttribute('data-sn-buy-now')) return;

    var actions = window.Shopify && window.Shopify.actions;
    if (!actions || typeof actions.updateCart !== 'function') return; // native form post fallback

    e.preventDefault();
    var btn = submitter || form.querySelector('[data-sn-add]');
    var id = form.querySelector('input[name="id"]').value;
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    actions.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: qty }] })
      .then(function (res) {
        if (res && res.userErrors && res.userErrors.length) {
          showCardError(form, res.userErrors[0].message);
          return;
        }
        if (res && res.cart && typeof res.cart.totalQuantity === 'number') setCartCount(res.cart.totalQuantity);
        else refreshCartCount();
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        if (typeof actions.openCart === 'function') return actions.openCart();
        openCart();
      })
      .catch(function () {
        HTMLFormElement.prototype.submit.call(form); // last resort: classic add to cart
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });

  /* ---------------- Header: mobile menu + sticky state ---------------- */
  function initHeader(root) {
    var header = root.querySelector ? root.querySelector('[data-sn-header]') : null;
    if (!header || header.dataset.snReady) return;
    header.dataset.snReady = '1';
    var shell = header.closest('[data-sn-header-shell]');
    var menuBtn = header.querySelector('[data-sn-menu-toggle]');
    var mobileNav = header.querySelector('#SnMobileNav');

    function setMenu(open) {
      if (!menuBtn || !mobileNav) return;
      menuBtn.setAttribute('aria-expanded', String(open));
      menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
      mobileNav.hidden = !open;
    }
    if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menuBtn && menuBtn.getAttribute('aria-expanded') === 'true') { setMenu(false); menuBtn.focus(); } });
    var mq = window.matchMedia('(min-width: 768px)');
    if (mq.addEventListener) mq.addEventListener('change', function (m) { if (m.matches) setMenu(false); });

    var overlay = !!d.querySelector('[data-snout-hero]');
    if (overlay) d.documentElement.classList.add('sn-has-hero');

    function reserve() {
      // Static (non-hero) pages keep the header's space so content never jumps when it becomes sticky.
      if (!shell) return;
      if (overlay) { shell.style.height = ''; return; }
      if (!header.classList.contains('is-stuck')) shell.style.height = header.offsetHeight + 'px';
    }
    reserve();
    window.addEventListener('resize', reserve);

    // On wide screens the base theme scrolls .page-wrapper instead of the window, so read whichever one moves.
    var wrap = d.querySelector('.page-wrapper');
    function scrolled() { return Math.max(window.scrollY || 0, wrap ? wrap.scrollTop : 0); }
    function scrollbar() {
      // Keep the sticky bar clear of the page-wrapper's own scrollbar
      var w = wrap ? Math.max(0, wrap.offsetWidth - wrap.clientWidth) : 0;
      d.documentElement.style.setProperty('--sn-scrollbar', w + 'px');
    }
    scrollbar();
    window.addEventListener('resize', scrollbar);

    var ticking = false;
    function update() {
      ticking = false;
      var limit = Math.max(120, (shell ? shell.offsetHeight : header.offsetHeight) + 40);
      var stuck = scrolled() > limit;
      if (stuck !== header.classList.contains('is-stuck')) header.classList.toggle('is-stuck', stuck);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrap) wrap.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ---------------- Tabs ---------------- */
  function initTabs(root) {
    root.querySelectorAll('[data-sn-tabs]').forEach(function (wrap) {
      if (wrap.dataset.snReady) return;
      wrap.dataset.snReady = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var all = wrap.querySelector('[data-sn-tabs-all]');
      var allLabel = wrap.querySelector('[data-sn-tabs-all-label]');
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          t.classList.toggle('is-active', on);
          var panel = d.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (all) all.href = tab.dataset.viewAll;
        if (allLabel) allLabel.textContent = 'View all ' + tab.dataset.viewLabel;
        if (focus) tab.focus();
        var current = d.getElementById(tab.getAttribute('aria-controls'));
        if (current) initRails(current);
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
      // Theme editor: selecting a tab block shows its panel
      wrap.addEventListener('shopify:block:select', function (e) {
        var t = e.detail && wrap.querySelector('#SnTab-' + e.detail.blockId);
        if (t) select(t, false);
      });
    });
  }

  /* ---------------- Phone rails: progress dots ---------------- */
  function initRails(root) {
    root.querySelectorAll('[data-sn-rail]').forEach(function (rail) {
      var hint = rail.nextElementSibling && rail.nextElementSibling.matches('[data-sn-rail-hint]') ? rail.nextElementSibling : null;
      if (!hint) return;
      var items = rail.children.length;
      if (hint.dataset.snReady && hint.children.length === items) return;
      hint.dataset.snReady = '1';
      hint.innerHTML = '';
      for (var i = 0; i < items; i++) hint.appendChild(d.createElement('span'));
      function paint() {
        var first = rail.children[0];
        if (!first) return;
        var step = first.getBoundingClientRect().width + 16;
        var idx = Math.min(items - 1, Math.round(rail.scrollLeft / step));
        Array.prototype.forEach.call(hint.children, function (dot, j) { dot.classList.toggle('is-active', j === idx); });
      }
      if (!rail.dataset.snRail) {
        rail.dataset.snRail = '1';
        rail.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
      }
      paint();
    });
  }

  /* ---------------- Video ---------------- */
  function initVideo(root) {
    root.querySelectorAll('[data-sn-video]').forEach(function (frame) {
      if (frame.dataset.snReady) return;
      frame.dataset.snReady = '1';
      var video = frame.querySelector('video');
      var overlay = frame.querySelector('[data-sn-video-play]');
      if (!overlay) return;

      // YouTube / Vimeo link: load the player only when the visitor presses play
      var embed = frame.getAttribute('data-sn-embed');
      if (!video && embed) {
        overlay.addEventListener('click', function () {
          var iframe = d.createElement('iframe');
          iframe.src = embed;
          iframe.title = overlay.getAttribute('aria-label') || 'Video';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          iframe.allowFullscreen = true;
          frame.appendChild(iframe);
          overlay.classList.add('is-hidden');
          overlay.setAttribute('tabindex', '-1');
        });
        return;
      }
      if (!video) return;
      overlay.addEventListener('click', function () {
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
      video.addEventListener('play', function () { overlay.classList.add('is-hidden'); });
      video.addEventListener('ended', function () { overlay.classList.remove('is-hidden'); video.controls = false; });
    });
  }

  /* ---------------- Catalog search: clear button ---------------- */
  function initSearch(root) {
    root.querySelectorAll('[data-sn-search]').forEach(function (form) {
      if (form.dataset.snReady) return;
      form.dataset.snReady = '1';
      var input = form.querySelector('input[name="q"]');
      var clear = form.querySelector('[data-sn-search-clear]');
      if (!input || !clear) return;
      var sync = function () { clear.hidden = input.value.trim() === ''; };
      input.addEventListener('input', sync);
      clear.addEventListener('click', function () { input.value = ''; sync(); input.focus(); });
      form.addEventListener('submit', function (e) { if (input.value.trim() === '') { e.preventDefault(); input.focus(); } });
      sync();
    });
    // Keep the active category pill visible when the pill row scrolls sideways (phones/tablets).
    root.querySelectorAll('.sn-toolbar .sn-tabs__list').forEach(function (list) {
      var active = list.querySelector('.is-active');
      if (!active || list.scrollWidth <= list.clientWidth) return;
      var lr = list.getBoundingClientRect(), ar = active.getBoundingClientRect();
      if (ar.right > lr.right || ar.left < lr.left) list.scrollLeft += ar.left - lr.left - 8;
    });
  }

  /* ---------------- Footer: mark the current page link ---------------- */
  function markFooter(root) {
    var links = root.querySelectorAll('.sn-footer__links a');
    for (var i = 0; i < links.length; i++) {
      if (links[i].pathname === location.pathname && location.pathname !== '/') {
        links[i].setAttribute('aria-current', 'page');
        break;
      }
    }
  }

  /* ---------------- Contact form: preselect the inquiry type from ?inquiry= ---------------- */
  function presetInquiry(root) {
    var want = null;
    try { want = new URLSearchParams(location.search).get('inquiry'); } catch (err) { return; }
    if (!want) return;
    want = want.toLowerCase();
    root.querySelectorAll('select[data-sn-inquiry-select]').forEach(function (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value.toLowerCase().indexOf(want) !== -1) { sel.selectedIndex = i; break; }
      }
    });
  }

  function focusFormMessages() {
    // Only rendered after a form submission (newsletter, contact, commission) — bring it into view.
    var msg = d.querySelector('[data-sn-autofocus]');
    if (!msg) return;
    msg.scrollIntoView({ block: 'center' });
    msg.focus({ preventScroll: true });
  }

  function init(root) {
    initHeader(root);
    initTabs(root);
    initRails(root);
    initVideo(root);
    initSearch(root);
    markFooter(root);
    presetInquiry(root);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); focusFormMessages(); });
  else { init(d); focusFormMessages(); }

  // Theme editor support
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
